module.exports = {
          srcSet: __webpack_public_path__ + "public/93c6e0e2941bae251b24b65b5e07fa88-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/93c6e0e2941bae251b24b65b5e07fa88-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/93c6e0e2941bae251b24b65b5e07fa88-40.png",
          toString:function(){return __webpack_public_path__ + "public/93c6e0e2941bae251b24b65b5e07fa88-40.png"},
          
          width: 40,
          height: 40
        }